import uuid from 'uuid/v4';

export default class Container {
  constructor(containerName = 'Room 1') {
    this.containerId = uuid();
    this.name = containerName;
    this.items = [];
    this.price = 0.0;
    this.charLabel = null;
  }

  addItem(item) {
    this.items.push(item.itemId);
    item.containerId = this.containerId; // eslint-disable-line no-param-reassign
    item.designId = this.designId; // eslint-disable-line no-param-reassign
  }
}
